import { Observable, of } from 'rxjs';

import { DroppanelStyle } from '../../../../elements/components/droppanel/entities/droppanel-style.entity';
import { FilterSizingType } from '../../base/entities/filter-sizing-type';
import { FilterType } from '../../base/entities/filter-type';
import { TagSearchFilterModifier, TagSearchFilterStyle } from '../../base/entities/tag-search-filter-style';
import { Filter } from '../../entities/filter.class';

export class TagSearchFilter extends Filter {
    sizing: FilterSizingType = FilterSizingType.FullWidth;
    placeholderMsg = '';
    style: TagSearchFilterStyle = TagSearchFilterStyle.Default;
    droppanelStyle: DroppanelStyle = DroppanelStyle.Default;
    modifiers: TagSearchFilterModifier[] = [];

    constructor(field: string) {
        super({
            field,
            filterType: FilterType.TagSearch
        });
    }

    autocompleteFct(term: string): Observable<string[]> {
        return of([]);
    }
}
